import { getProethicaTestDescriptor } from "@constants/demo/proethica-tests";
import { useAppTheme } from "@hooks/useAppTheme";
import { Box } from "@memorang/ui";
import { Text } from "react-native-paper";
import useSessionStore from "../../hooks/useSessionStore";

const StudySessionAppBarLeft = ({
	title,
	userName,
	numericId,
}: {
	title: string;
	userName: string;
	numericId: number;
}) => {
	const theme = useAppTheme();
	const proethicaTestKind = useSessionStore((state) => state.proethicaTestKind);
	const subtitle =
		getProethicaTestDescriptor(proethicaTestKind)?.title ??
		`${userName || ""} • Test #${numericId}`;
	return (
		<Box flexDirection="column" gap={2}>
			<Text
				variant="titleLarge"
				style={{
					color: theme.colors.white,
				}}
			>
				{title}
			</Text>
			<Text
				variant="bodyLarge"
				style={{ textTransform: "capitalize", color: theme.colors.white }}
			>
				{subtitle}
			</Text>
		</Box>
	);
};

export default StudySessionAppBarLeft;
